var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _CountrySelector_instances, exposeChildrens_fn, updateColorSelect_fn, updateSelectedState_fn, updateCountryDefault_fn;
import { C as Component } from "./utilities-Da0sjanJ.js";
class CountrySelector extends Component {
  constructor() {
    super();
    __privateAdd(this, _CountrySelector_instances);
  }
  connectedCallback() {
    super.connectedCallback();
    const { countrySelect } = this.refs;
    countrySelect.options[0].textContent = countrySelect.dataset.label || "Country/region";
    __privateMethod(this, _CountrySelector_instances, exposeChildrens_fn).call(this);
    __privateMethod(this, _CountrySelector_instances, updateCountryDefault_fn).call(this, countrySelect);
  }
  toggleProvinces(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    const { provinceSelect } = this.refs;
    const provinceWrapper = provinceSelect.closest(".field");
    const countrySelect = event.target;
    const selected = countrySelect.options[countrySelect.selectedIndex];
    const provinces = JSON.parse(selected.dataset.provinces || "[]");
    __privateMethod(this, _CountrySelector_instances, updateColorSelect_fn).call(this, countrySelect);
    __privateMethod(this, _CountrySelector_instances, updateSelectedState_fn).call(this, countrySelect);
    if (provinces.length === 0) {
      provinceWrapper.setAttribute("hidden", true);
      provinceSelect.innerHTML = "";
      return;
    }
    provinceWrapper.removeAttribute("hidden");
    provinceSelect.innerHTML = provinces.map((p) => {
      return `<option value="${p[0]}">${p[1]}</option>`;
    }).join("");
    __privateMethod(this, _CountrySelector_instances, updateColorSelect_fn).call(this, provinceSelect);
    __privateMethod(this, _CountrySelector_instances, updateSelectedState_fn).call(this, provinceSelect);
  }
}
_CountrySelector_instances = new WeakSet();
exposeChildrens_fn = function() {
  const { countrySelect, provinceSelect } = this.refs;
  this.countrySelect = countrySelect;
  this.provinceSelect = provinceSelect;
};
updateColorSelect_fn = function(select) {
  if (select.value === "---") {
    select.classList.remove("color-text-input-default");
    return;
  }
  select.classList.add("color-text-input-default");
};
updateSelectedState_fn = function(select) {
  select.value !== "---" ? select.setAttribute("selected", "") : select.removeAttribute("selected");
};
updateCountryDefault_fn = function(select) {
  const countryDefault = select.dataset.default;
  if (countryDefault) {
    select.value = countryDefault;
    this.toggleProvinces(select);
    select.dispatchEvent(new Event("change"));
  }
};
if (!customElements.get("country-selector")) {
  customElements.define("country-selector", CountrySelector);
}
